import classes from "./Section3.module.css";
import { useNavigate } from "react-router-dom";

export default function Section3() {
  const navigate = useNavigate();

  return (
    <section className={classes.section3Wrapper}>
      {/* Overlay */}
      <div className={classes.overlay}></div>

      <div className={classes.content}>
        <h2>Comprehensive IT Hardware & Networking Solutions</h2>

        <p>
          <b>Prime Cloud Systems</b> provides high-performance IT hardware and
          networking equipment for home users, IT professionals, and businesses
          across the USA. Our extensive range of new and refurbished products,
          including servers, desktop PCs, laptops, storage devices, and
          networking components, helps customers build, upgrade, and maintain
          their IT systems efficiently and cost-effectively.
        </p>

        <p>
          Every product is rigorously tested for reliability, performance, and
          compatibility, ensuring your technology runs smoothly without
          compromising security or uptime.
        </p>

        <button
          className={classes.ctaButton}
          onClick={() => navigate("/contact-us")}
          aria-label="Contact Prime Cloud Systems for IT hardware solutions"
        >
          Get in Touch
        </button>
      </div>
    </section>
  );
}
